import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useMatch } from '../../contexts/MatchContext';

export default function ResultsLanding() {
  const { t } = useTranslation();
  const { match } = useMatch();

  return (
    <Box sx={{ width: '90%', maxWidth: 720, mx: 'auto', pt: 3, pb: 2 }}>
      <Button
        component={Link}
        to={`/${match.alias}/score-table`}
        sx={{ mb: 1.5, textTransform: 'none' }}
        fullWidth
        color="primary"
        variant="contained"
      >
        {match.scoresPublished === 'verify-only' ? t('results.liveVerify') : t('results.liveResults')}
      </Button>
      <Button
        component={Link}
        to={`/${match.alias}/shooter-stats`}
        sx={{ mb: 1.5, textTransform: 'none' }}
        fullWidth
        color="primary"
        variant="contained"
      >
        {t('results.shooterStats')}
      </Button>
      <Button
        component={Link}
        to={`/${match.alias}/compare-shooters`}
        sx={{ mb: 1.5, textTransform: 'none' }}
        fullWidth
        color="primary"
        variant="contained"
      >
        {t('results.compareShooters')}
      </Button>
      <Button
        component={Link}
        to={`/${match.alias}/flags-podium`}
        sx={{ mb: 1.5, textTransform: 'none' }}
        fullWidth
        color="primary"
        variant="contained"
      >
        {t('results.flagsPodium')}
      </Button>
    </Box>
  );
}
